import { createContext, useEffect, useReducer, useState } from "react";
import {
  sendToKitchenCustomer,
  getOrderStatus,
  getOrder,
} from "../utils/restaurantOrder";
export const CustomerOrderContext = createContext({});
export const CustomerOrderProvider = ({ children }) => {
  const [customerOrderContext, setCustomerOrderContext] = useState({});
  const [orderTotal, setOrderTotal] = useState(0);
  const [tableNumber, setTableNumber] = useState("");
  const [orderType, setOrderType] = useState("tableside");
  const [orderMessage, setOrderMessage] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [orderID, setOrderID] = useState("");
  useEffect(() => {
    if (localStorage.getItem("orderID")) {
      const id = localStorage.getItem("orderID");
      setOrderID(id);
      getOrder(
        id,
        setCustomerOrderContext,
        setOrderMessage,
        setTableNumber,
        setCustomerEmail,
        setOrderStatus
      );
    }
  }, []);
  useEffect(() => {
    if (orderID) {
      getOrderStatus(orderID, setOrderStatus);
    }
  }, [orderID]);
  useEffect(() => {
    var orderValue = 0;
    Object.keys(customerOrderContext).map((index) => {
      var tempObject = customerOrderContext[index];
      var price = tempObject["itemTotal"];
      orderValue = orderValue + price;
    });
    setOrderTotal(orderValue);
  }, [customerOrderContext]);
  const sendToKitchenFunction = (loaderClassFunction) => {
    sendToKitchenCustomer(
      customerOrderContext,
      orderType,
      orderTotal,
      tableNumber,
      orderMessage,
      customerEmail,
      setOrderStatus,
      setOrderID,
      loaderClassFunction
    );
  };
  const value = {
    customerOrderContext,
    setCustomerOrderContext,
    orderTotal,
    tableNumber,
    setTableNumber,
    orderType,
    setOrderType,
    sendToKitchenFunction,
    customerEmail,
    setCustomerEmail,
    orderMessage,
    setOrderMessage,
    orderStatus,
  };
  return (
    <CustomerOrderContext.Provider value={value}>
      {children}
    </CustomerOrderContext.Provider>
  );
};
